import React from 'react'

import './NoElementsMessage.css';
import { getTranslation } from '../../assets/creator/translations';
const NoElementsMessage = () => (
    <div className="no-elements">
        <img className="no-elements__img" src="./img/no_elements.svg" alt="" />
        <p className="no-elements__text">{getTranslation("BackCreator")}</p>
        <p className="no-elements__text">{getTranslation("NEl_DragElements")}</p>
        <p className="no-elements__text">{getTranslation("NEl_ToAdjustAppearance")}</p>
    </div>
)

export default NoElementsMessage;